"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StickyBottomBar_1 = require("./StickyBottomBar");
exports.default = StickyBottomBar_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/StickyBottomBar/index.js
// module id = 1413
// module chunks = 8